<template>
  <div
    :style="{
      backgroundColor: extras.message ? extras.message.bg : '#f5f6f7',
    }"
    class="m-journalism top-nav"
    v-if="extras.message.display === 1"
    id="message"
  >
    <WapTitle
      v-if="extras.messageTitle.display == 1"
      :title="extras.messageTitle.model || title"
      :icon="icon"
      :titleFont="extras.messageTitle.color"
    />
    <ul
      class="tab"
      v-if="columns.length > 1 || (columns.length == 1 && columns[0].id != 0)"
    >
      <li
        v-for="(item, index) in columns"
        :key="index"
        :class="{ active: item.id == currentId }"
        @click="columnClick(item)"
      >
        {{ item.name }}
      </li>
    </ul>
    <ul class="list-time1">
      <!-- list-time1 第一套样式 -->
      <!-- list-time2 第二套样式 -->
      <li
        v-for="(item, index) in articles"
        :key="index"
        :style="{
          display: isShowMore == false && index > 3 ? 'none' : '',
        }"
      >
        <img
          :src="
            item.coverImageRealPath
              ? item.coverImageRealPath
              : require('@/assets/images/wap/defaultNewBig.png')
          "
        />
        <div class="body-jour divlist">
          <div class="title" v-show="extras.contentTitle.display == 1">
            <!--            {{ item.name }}-->
            <a
              class="title"
              target="_blank"
              v-if="extras.contentTitle.display == 1 && item.useLinkUrl == 1"
              :href="item.linkUrl"
              >{{ item.name }}</a
            >
            <a
              class="title"
              target="_blank"
              v-if="extras.contentTitle.display == 1 && item.useLinkUrl != 1"
              :href="item.shortUrl"
              >{{ item.name }}</a
            >
          </div>
          <div class="text" v-show="extras.summary.display == 1">
            {{ item.desc }}
          </div>
          <span v-show="extras.sendTime.display == 1">{{
            item.createTime ? item.createTime.substr(0, 10) : ""
          }}</span>
        </div>
      </li>
      <div class="no-data" v-if="articles && articles.length == 0">
        <img :src="require('@/assets/images/nodata.png')" />
        <div class="no-data-text">暂无数据</div>
      </div>
    </ul>
    <img
      class="more"
      v-if="articles && articles.length > 4"
      :src="
        isShowMore == false
          ? require('@/assets/images/wap/showmore.png')
          : require('@/assets/images/wap/hidemore.png')
      "
      @click="showMoreArticle"
    />
  </div>
</template>

<script>
import WapTitle from "@/components/index/WapTitle.vue";
import { URLS } from "fire-wind-water";
export default {
  props: {
    newsInfo: [],
    extras: Object,
  },
  components: {
    WapTitle,
  },
  data() {
    return {
      title: "新闻资讯",
      icon: require("@/assets/images/wap/xinwen.png"),
      columns: [],
      articles: [],
      currentId: 0,
      isShowMore: false,
    };
  },
  created() {},
  computed: {
    // columns() {
    //   let tempArticles = this.newsInfo.article;
    //   let tempColumns = this.newsInfo.column;
    //   const columns = [
    //     {
    //       id: 0,
    //       name: "新闻资讯",
    //       article: tempArticles,
    //     },
    //   ];
    //   for (let item in tempArticles) {
    //     if (item.desc) {
    //       item.desc = item.desc.substr(0, 130);
    //     }
    //   }
    //   for (let i in tempColumns) {
    //     columns.push(tempColumns[i]);
    //   }
    //   return columns;
    // },
    // articles() {
    //   return this.columns[this.currentId].article;
    // },
  },
  mounted() {
    //this.initColumns();
    let tempColumns = this.getColumns.articleInitColumns(
      this.newsInfo.column,
      this.newsInfo.article,
      "热门资讯",
      true
    );
    this.columns = tempColumns;
    this.articles = this.columns[0] ? this.columns[0].article : [];
    this.currentId = this.columns[0] ? this.columns[0].id : 0;
  },
  methods: {
    columnClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = item.id;
      this.articles = item.article;
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style scoped></style>
